export default{styledText:"w_Dz",blue:"w_D0",gray:"w_D1",green:"w_D2",leading:"w_D3",small:"w_D4",large:"w_D5"};
